import { Link, useLocation, useNavigate } from "react-router-dom";
import AdminProfile from "../../images/AdminProfile.svg";
import logo from '../../images/logo.png';
import { Row, Col, List } from "reactstrap";
import { useContext, useState, useEffect } from "react";
import { AuthContext, AuthContextType,useAuth } from "hooks/useAuth";
import { Calendar, ChatLeftText, ColumnsGap, EnvelopeOpen, Gear, PersonCheckFill,Wechat } from "react-bootstrap-icons";

const LINKS = [
  {
    path: '/app/dashboard',
    icon: <ColumnsGap />,
    linkText: "Dashboard"
  },
  {
    path: '/app/customers',
    icon: <PersonCheckFill />,
    linkText: 'Customers'
  },
  {
    path: '/app/partners',
    icon: <Wechat/>,
    linkText: 'Partners'
  },
  {
    path: '/app/bookings',
    icon: <Calendar />,
    linkText: 'Bookings'
  },
  {
    path: '/app/leads',
    icon: <EnvelopeOpen />,
    linkText: 'Leads'
  },
  {
    path: '/app/reviews',
    icon: <ChatLeftText />,
    linkText: 'Reviews'
  },
  {
    path: '/app/settings',
    icon: <Gear />,
    linkText: 'Settings'
  }
]

const Sidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();  
  const [activeLink, setActiveLink] = useState<string>(pathname);
  const authContext = useAuth();
  const auth = authContext?.auth;


    console.log("Auth data in Sidebar:", auth);  

  const { setAuthData } = useContext(AuthContext) as AuthContextType;


  const handleLogout = async () => {
    await setAuthData({ loading: false, data: null });
    window.localStorage.removeItem('accessToken');
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('refreshTokenExpiration');
    console.log("activeLink", activeLink);

    navigate('/', { replace: true });
  };

  useEffect(() => {
    setActiveLink(pathname);
  }, [pathname]); 

  const isActiveLink = (path: string) => {
    if (pathname === path) return true;
  
    const prefixPaths = ['/app/customers', '/app/order-bookings'];
    if (prefixPaths.includes(path) && pathname.startsWith(path)) return true;
  
    return false;
  };

  return (
    <>
      <Row className="h100">
        <Col md="12" className="admin-profile-container">
          <Row>
            <Col sm="12" className="text-center mb-5">
              <img src={logo} alt="Logo" className="logo-class mt-3" />
            </Col>
            <Col sm="8" className="admin-info text-sm-end">
              <h6 className="admin-name w-100">
                Hello, {auth?.data?.user?.firstName || "Admin"}, {auth?.data?.user?.lastName || ""}
              </h6>
              <span className="admin-role w-100">{auth?.data?.user?.role}</span>
            </Col>
            <Col sm="4" className="text-start">
              <img src={AdminProfile} alt="" className="img-fluid admin-profile" />
            </Col>
          </Row>

          <Row>
            <Col sm="12">
              <Row className="mt-4">
                <List type="unstyled">
                  {
                    LINKS.map((row, index) => {
                      const { path, icon, linkText } = row;
                      const isActive = isActiveLink(path);

                      return (
                        <li className="admin-navigation-iteam" key={`nav-${index + 1}`}>
                          <Link
                            to={path}
                            state={{ heading: linkText }}
                            className={`w100 d-flex admin-navigation ${isActive ? 'active' : ''}`}
                            onClick={() => setActiveLink(path)}
                          >
                            <span className={`mx-0 ${isActive?'text-red' : ''}`}>{icon}</span>
                            <span className={`mx-2 ${isActive ? 'text-red' : ''}`}>{linkText}</span>
                          </Link>
                        </li>
                      );
                    })
                  }
                </List>
              </Row>
            </Col>
          </Row>
        </Col>
        <div className="logout-button text-center">
          <button className=" " onClick={handleLogout}>
            <i className="fa fa-power-off me-2"></i>
            <span>Log Out</span>
          </button>
        </div>
      </Row>
    </>
  );
};

export default Sidebar;
